export default __webpack_public_path__ + "static/media/withdraw_task.8b0a8b9a.svg";